"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrnamentalBreakCss = void 0;
/**
 * Can contain previewer only styles
 */
const getOrnamentalBreakCss = (ornamentalBreakWidth, themeId, isPreviewer) => {
    return `
    .${themeId} .ornamental-break{
      text-align: center;
      display: block;
      width: 100%;
      padding: ${isPreviewer ? '1.2rem' : '0.8rem'} 0rem;
    }
    
    .${themeId} .ornamental-break img{
      width: ${ornamentalBreakWidth || 50}%;
    }
  `;
};
exports.getOrnamentalBreakCss = getOrnamentalBreakCss;
